export const raffle = {
  raffleTitle: "Raffles",
  raffleBtnMyTickets: "My Tickets",
  rafflePrize: "Prize",
  raffleBtnBuy: "Buy Ticket",
  raffleStatus: "ACTIVE",
  raffleModalTitle: "Buy Tickets for ",
  raffleModalPrice: "Ticket Price",
  raffleModalTotalPrice: "TOTAL PRICE",
  raffleModalQuantity: "Enter a number",
  raffleModalBtnBuy: "Buy Ticket(s)",
  raffleModalBuyQuantity: "How many tickets do you want to buy?",
  raffleModalChooseNumber: "Choose a number",
  raffleModalChooseRandom: "Random number",
  raffleModalBackBtn: "Back",
  raffleTicketPurchase: "Purchase successful!",
  raffleTicketCreatedMessage: "Please enter a valid number for each ticket.",
  raffleTicketPurchaseError: "Error purchasing tickets. Please try again later.",
  raffleErrorMessage: "Error purchasing tickets.",
};
